import React from "react";
import {
    ContextStatus,
    DepositPhase,
    DepositState,
    PaymentStateStatus,
    WithdrawState
} from "../../payments/PaymentsReducer";
import {GlobalPayload, OnboardingPagePayload} from "../../contenful/types";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {CurrencyDefinition, PaymentMethod, Settings, UserInfo} from "../../http/protocol";
import {AppState} from "../../RootReducer";
import {LoginStatus, Status} from "../../http/Types";
import {Dispatch} from "redux";
import {initDeposit, showCashier, updateDepositPhase} from "../../payments/DepositActions";
import {connect} from "react-redux";
import CryptoDeposit from "./sharedcomponents/CryptoDeposit";
import {t} from "../../i18n";
import Loader from "../../layout/Loader";
import ChooseAmount from "../deposit/ChooseAmount";
import {BrandA} from "../buttons/buttons";
import { ReactNode } from "react-markdown";


interface State {
    phase:number;
}

type AllProps = PropsFromState & PropsFromDispatch & OtherProps;

export class NanoPaymentComponent extends React.Component<AllProps, State> {
    constructor(props:AllProps) {
        super(props);
        this.state = {phase:1};
    }

    renderWithdraw() {
      return <div></div>;
    }

    componentDidMount() {
        this.props.updatePhase && this.props.updatePhase(DepositPhase.CHOOSE_AMOUNT);
        if(!this.props.amountRequired) {
            this.props.initDeposit && this.props.initDeposit();
            this.setState({phase:1});
        }
    }



    handleOnclick() {
        this.props.initDeposit();
        this.setState({phase:1});
    }

    renderDeposit() {
        let phase:number = this.state.phase;
        let deposit = this.props.deposit;
        let dialog = deposit.depositDialog;
        let currencyCode = this.props.activeCurrency || "";
        let decimals: number = 0;
        if(this.props.user && this.props.user.currencies) {
            this.props.user.currencies.forEach((cd:CurrencyDefinition) => {
                if(cd.fractionalDigits && dialog && dialog.payment && cd.code == dialog.payment.currency) {
                    decimals = cd.fractionalDigits;
                }
            })
        }
        if(!deposit || !deposit.activeCurrency || !deposit.methods  || !deposit.methods[deposit.activeCurrency]) {
            return <span/>
        }
        if(phase == 0) {
            return(
                <div className="deposit-content">
                    <ChooseAmount handleOnClick={() => this.handleOnclick()} />
                </div>
            )
        }
        if(phase == 1) {
            if(this.props.deposit.depositContextStatus === ContextStatus.ERROR) {
                return (
                    <div className={"deposit-content"}>
                        <p className="text-danger" style={{textAlign:"center"}}>
                            {t("deposit.context-error")}
                        </p>
                    </div>
                )
            }
            if(this.props.deposit.status == PaymentStateStatus.DEPOSIT_INITIATED && !this.props.error) {
                return (
                    <div className={"deposit-content"}>
                        <p className="text-info" style={{textAlign:"center"}}>{t("payments.getting-address")}</p>
                        <Loader />
                    </div>
                )
            }
            return(
                <div className="deposit-content">
                    {dialog
                    && dialog.payment
                    && <CryptoDeposit address={dialog.customContext.address}
                                      currencyCode={currencyCode}
                                      decimals={decimals}
                                      generateNew={this.props.activeMethod?.canReuseAddress}
                                      warningText={t("payments.maxDecimalsWarning")}
                    />
                    }
                    <div className={"alert alert-info nano-warning"}>
                        {t("payments.method.nowpayments.info")}
                    </div>
                    {this.props.handleClickStartPlaying && <BrandA className={"btn btn-cta full-width"} onClick={this.props.handleClickStartPlaying}>{t("global.startPlaying")}</BrandA>}
                </div>
            )
        }

    }

    render(): ReactNode | ReactNode[]  {
        if(this.props.type == "withdraw") {
            return this.renderWithdraw()
        }
        if(this.props.type == "deposit") {
            return  this.renderDeposit()
        }
    }
}

interface OtherProps extends RouteComponentProps {
    type: string
    withdraw? : WithdrawState;
    handleClickOk?: () => void;
    handleClickStartPlaying?: () => void;
    amountRequired?:boolean;
    code?:string;
}

interface PropsFromState {
    deposit: DepositState;
    onboardingpage?: OnboardingPagePayload;
    settings?: Settings;
    registrationStatus: boolean;
    user?: UserInfo;
    show?: boolean;
    activeCurrency?:string;
    activeMethod?:PaymentMethod;
    error?:string;
}

interface PropsFromDispatch {
    hide: () => void;
    updatePhase: typeof updateDepositPhase;
    initDeposit: typeof initDeposit;
}


const mapStateToProps = ({payments, contentful, settings, user} : AppState) => {
    let status = false;
    if(user.registration && user.registration.status) {
        if(user.registration.status == Status.SUCCESS) {
            status = true;
        }
    }
    return {
        deposit : payments.deposit,
        onboardingpage: contentful.onboardingpage,
        settings: settings.settings,
        loggedIn : LoginStatus.LOGGED_IN == user.status,
        registrationStatus : status,
        user: user.user,
        show: payments.cashier.showCashierModal,
        activeCurrency: user.activeCurrency,
        activeMethod: payments.deposit.activeMethod,
        error: payments.deposit.error
    }
}

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        hide : () => dispatch(showCashier(false)),
        updatePhase : (phase:DepositPhase) => dispatch(updateDepositPhase(phase)),
        initDeposit : () => dispatch(initDeposit() as any),
    }
)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter<AllProps,any>(NanoPaymentComponent));